import {
	Instance,
	types,
	flow,
	applySnapshot,
	destroy,
} from 'mobx-state-tree';
import { getMainGoal, postMainGoal, saveMainGoal } from '@common/api/mainGoals';
import { postSteps, deleteSteps } from '@common/api/goalsSteps';

import Goal, { IGoalModel } from './Goal';

const MainGoal = types
	.model('MainGoal', {
		id: types.maybe(types.number),
		student_id: types.maybe(types.number),
		title: types.optional(types.string, ''),
		goals: types.maybe(types.optional(types.array(Goal), [])),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			try {
				self.loading = true;
				const result = yield getMainGoal();
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			try {
				self.loading = true;
				let result = {};
				if (self.id) {
					result = yield saveMainGoal(self.id, data);
				} else {
					result = yield postMainGoal(data);
				}
				applySnapshot(self, {
					...self,
					...result,
				});
			} finally {
				self.loading = false;
			}
		}),
		removeGoal(goal: IGoalModel) {
			destroy(goal);
		},
		removeSteps: flow(function* (ids: number[]) {
			self.loading = true;
			try {
				yield deleteSteps({
					steps: [
						...ids.map((id) => ({
							id,
						})),
					],
				});
			} finally {
				self.loading = false;
			}
		}),
		addSteps: flow(function* (data: any[]) {
			self.loading = true;
			try {
				if (data.length) {
					yield postSteps({ steps: data });
				}
			} finally {
				self.loading = false;
			}
		}),
	}));
export default MainGoal;

export interface IMainGoalModel extends Instance<typeof MainGoal> {}
